import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { FiSearch } from 'react-icons/fi';
import {
  format,
  startOfMonth,
  startOfYear,
  endOfMonth,
  endOfYear,
  startOfDay,
} from 'date-fns';
import { useTheme as useThemeStyled } from 'styled-components';

// import { useToast } from '../../hooks/ToastContext';
import { useAuth } from '../../context/AuthContext';
import { useConfigs } from '../../context/ConfigsContext';
import { useTheme } from '../../context/ThemeContext';
import { useIndexedDB } from '../../context/IndexedDBContext';

import {
  Container,
  // Background,
  // LoadingContainer,
  // Loading,
  LinhaBuscar,
  InputData,
  InputMes,
  InputAno,
  BotaoPesquisar,
  TooltipContainer,
  TooltipText,
  TooltipStrong,
  SecaoContainer,
  ObjetoContainer,
  ObjetoTitulo,
  AnimatedCard,
  CartaoValor,
  CartaoPercentual,
  CartaoDescricao,
} from './styles';

import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  BarChart,
  Bar,
  RadarChart,
  Radar,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
} from 'recharts';

import { ISecao, IObjeto } from '../../utils/apiFake';

import {
  eFiltroPagina,
  Pagina,
  Secao,
  BuscarSomentePaginas,
  buscarSecoesPeriodo,
  buscarSecoesDia,
  buscarSecoesMes,
  buscarSecoesAno,
  buscarSecoesGeral,
  converterDadosParaSecoes,
} from '../../utils/apiTemp';

import api from '../../services/api';

import LeftSideBar from '../LeftSideBar';

const Home: React.FC = () => {
  const { user } = useAuth();

  const CustomTooltip = ({
    active,
    payload,
  }: {
    active?: boolean;
    payload?: any[];
  }) => {
    if (active && payload && payload.length) {
      return (
        <TooltipContainer>
          <TooltipText>{payload[0].name}</TooltipText>
          <TooltipText>
            <TooltipStrong>Value:</TooltipStrong> {payload[0].value}
          </TooltipText>
        </TooltipContainer>
      );
    }

    return null;
  };

  const getDataInicial = (filtroPagina: string | undefined): string => {
    const hoje = new Date();

    if (filtroPagina) {
      switch (filtroPagina) {
        case 'DIARIO':
          return format(startOfDay(hoje), 'yyyy-MM-dd');
        // case "SEMANAL":
        //   return format(startOfWeek(hoje), "yyyy-MM-dd"); // Início da semana
        case 'MENSAL':
          return format(startOfMonth(hoje), 'yyyy-MM'); // Início do mês
        case 'ANUAL':
          return format(startOfYear(hoje), 'yyyy'); // Início do ano
        default:
          return format(startOfMonth(hoje), 'yyyy-MM-dd'); // Início do mês
      }
    }

    return format(hoje, 'yyyy-MM-dd');
  };

  const getDataFinal = (filtroPagina: string | undefined): string => {
    const hoje = new Date();

    if (filtroPagina) {
      switch (filtroPagina) {
        case 'DIARIO':
          return format(startOfDay(hoje), 'yyyy-MM-dd');
        // case "SEMANAL":
        //   return format(endOfWeek(hoje), "yyyy-MM-dd"); // Fim da semana
        case 'MENSAL':
          return format(endOfMonth(hoje), 'yyyy-MM'); // Fim do mês
        case 'ANUAL':
          return format(endOfYear(hoje), 'yyyy'); // Fim do ano
        default:
          return format(endOfMonth(hoje), 'yyyy-MM-dd'); // Fim do mês
      }
    }

    return format(hoje, 'yyyy-MM-dd');
  };

  const [, setPaginas] = useState<Pagina[]>([]);
  const { id: idInicial } = useParams<{ id: string }>();
  const [pagina, setPagina] = useState<Pagina | undefined>(undefined);
  const [secoes, setSecoes] = useState<ISecao[]>([]);

  const inputDataInicial = useRef<HTMLInputElement>(null);
  const inputDataFinal = useRef<HTMLInputElement>(null);

  const [dataInicial, setDataInicial] = useState('');
  const [dataInicialErro, setDataInicialErro] = useState('');
  const [dataFinal, setDataFinal] = useState('');
  const [dataFinalErro, setDataFinalErro] = useState('');

  //   const { usuario, senha } = useAuth();
  //   const { addToast } = useToast();
  const { cores } = useConfigs();
  const { setTheme, chaveStorageTheme } = useTheme();
  const { lerIndexedDB, gravarIndexedDB } = useIndexedDB();
  const themeStyled = useThemeStyled(); // Acessa o tema atual do styled components

  //   const [clientes, setClientes] = useState<IClientesCadastrados[]>([]);
  //   const [clientesExibir, setClientesExibir] = useState<IClientesCadastrados[]>([]);
  // const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    //     let token: string = '';
    //     setLoading(true);
    //     apiLiberacao.post('/sizex/api/obtertoken', `userName=${usuario}&password=${senha}&grant_type=password`).then((response) => {
    //       token = response.data.access_token;

    //       apiLiberacao.get('/sizex/api/liberacao/todas-pessoas-clientes', {
    //         headers: {
    //           'Authorization': `Bearer ${token}`,
    //         }
    //       }).then((resp) => {
    //         if (resp.data.sucesso) {
    //           setClientes(resp.data.dados);
    //         }
    //         setLoading(false);
    //       });
    //     }).catch((error) => {
    //       setLoading(false);
    //       addToast({
    //         type: 'info',
    //         title: 'Erro na autenticação',
    //         description: 'Ocorreu algum erro na autenticação do usuário no servidor.',
    //       });
    //     })

    lerIndexedDB<string>(chaveStorageTheme).then(valorChave => {
      if (valorChave) {
        if (valorChave === 'light' || valorChave === 'dark') {
          setTheme(valorChave);
        }
      } else {
        setTheme('dark');
        gravarIndexedDB(chaveStorageTheme, 'dark');
      }
    });
  }, [setTheme, chaveStorageTheme, lerIndexedDB, gravarIndexedDB]);

  useEffect(() => {
    let initialPaginas: Pagina[] = [];
    // Se for empresa exemplo, pega dados fixos aqui no front
    if (user.empresa.url_frontend.toUpperCase() === 'EXEMPLO') {
      initialPaginas = BuscarSomentePaginas();

      setPaginas(initialPaginas);

      if (idInicial === undefined) {
        if (initialPaginas.length > 0) {
          setPagina(initialPaginas[0]);
        }
      } else {
        const paginaEncontrada = initialPaginas.find(
          pagina => pagina.id === idInicial,
        );
        setPagina(paginaEncontrada);
      }
    } else {
      // senão busca no back-end
      api.get<Pagina[]>('/painel/paginas').then(response => {
        const dadosRetornados: Pagina[] = response.data;
        setPaginas(dadosRetornados);

        if (idInicial === undefined) {
          if (dadosRetornados.length > 0) {
            setPagina(dadosRetornados[0]);
          }
        } else {
          const paginaEncontrada = dadosRetornados.find(
            pagina => pagina.id === idInicial,
          );
          setPagina(paginaEncontrada);
        }
      });
    }
  }, [idInicial, user.empresa.url_frontend]);

  // const buscar = useCallback(async() => {
  const buscar = useCallback(
    async (dataInicialArg: string, dataFinalArg: string) => {
      setSecoes([]);
      if (pagina) {
        let secoesLocal: Secao[] | undefined = undefined;

        // É AQUI QUE VOU TER QUE ALTERAR, MAIS AS FUNÇÕES DO BUSCAR: buscarSecoesPeriodo, etc
        if (pagina.filtro === eFiltroPagina.PERIODO) {
          secoesLocal = await buscarSecoesPeriodo(
            pagina.id,
            dataInicialArg,
            dataFinalArg,
            user.empresa.url_frontend,
          );
        } else if (pagina.filtro === eFiltroPagina.DIARIO) {
          secoesLocal = await buscarSecoesDia(
            pagina.id,
            dataInicialArg,
            user.empresa.url_frontend,
          );
        } else if (pagina.filtro === eFiltroPagina.MENSAL) {
          secoesLocal = await buscarSecoesMes(
            pagina.id,
            dataInicialArg,
            user.empresa.url_frontend,
          );
        } else if (pagina.filtro === eFiltroPagina.ANUAL) {
          secoesLocal = await buscarSecoesAno(
            pagina.id,
            dataInicialArg,
            user.empresa.url_frontend,
          );
        } else {
          // FiltroPagina.GERAL
          secoesLocal = await buscarSecoesGeral(
            pagina.id,
            user.empresa.url_frontend,
          );
        }

        setSecoes(converterDadosParaSecoes(secoesLocal));
      }
    },
    [pagina, user.empresa.url_frontend],
  );

  useEffect(() => {
    setSecoes([]);
    if (pagina) {
      let dataInicialLocal: string = '';
      let dataFinalLocal: string = '';
      if (pagina.filtro === eFiltroPagina.PERIODO) {
        dataInicialLocal = getDataInicial(pagina.filtro);
        dataFinalLocal = getDataFinal(pagina.filtro);
        setDataInicial(dataInicialLocal);
        setDataFinal(dataFinalLocal);
        buscar(dataInicialLocal, dataFinalLocal);
      } else if (pagina.filtro === eFiltroPagina.DIARIO) {
        dataInicialLocal = getDataInicial(pagina.filtro);
        setDataInicial(dataInicialLocal);
        buscar(dataInicialLocal, '');
      } else if (pagina.filtro === eFiltroPagina.MENSAL) {
        dataInicialLocal = getDataInicial(pagina.filtro);
        setDataInicial(dataInicialLocal);
        buscar(dataInicialLocal, '');
      } else if (pagina.filtro === eFiltroPagina.ANUAL) {
        dataInicialLocal = getDataInicial(pagina.filtro);
        setDataInicial(dataInicialLocal);
        buscar(dataInicialLocal, '');
      } else {
        // FiltroPagina.GERAL
        buscar('', '');
      }
    }
  }, [pagina, buscar]);

  const aoAlterarDataInicial = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setDataInicial(event.target.value);
      setDataInicialErro('');
    },
    [setDataInicial, setDataInicialErro],
  );

  const aoAlterarDataFinal = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setDataFinal(event.target.value);
      setDataFinalErro('');
    },
    [setDataFinal, setDataFinalErro],
  );

  function normalizeKey(key: string): string {
    return key
      .normalize('NFD') // Normaliza caracteres acentuados
      .replace(/[\u0300-\u036f]/g, '') // Remove os acentos
      .replace(/\s+/g, '_') // Substitui espaços por underscores
      .replace(/[^a-zA-Z0-9_]/g, '') // Remove caracteres especiais, mantendo letras, números e underscores
      .toLowerCase(); // Converte para minúsculas
  }

  return (
    <>
      <LeftSideBar />

      <Container>
        {/* {loading && (
          <LoadingContainer>
            <Loading size={60} />
          </LoadingContainer>
        )} */}

        {pagina?.filtro === eFiltroPagina.DIARIO && (
          <LinhaBuscar>
            <InputData
              variant="outlined"
              margin="normal"
              // required
              // fullWidth
              autoFocus
              id="dataIni"
              label="Dia"
              name="dataIni"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              inputRef={inputDataInicial}
              value={dataInicial}
              onChange={aoAlterarDataInicial}
              error={dataInicialErro !== ''}
              helperText={dataInicialErro}
            />
            <BotaoPesquisar cores={cores}>
              <button
                type="button"
                onClick={() => buscar(dataInicial, '')}
                // title="Incluir Cliente"
              >
                <div>
                  <FiSearch />
                </div>
              </button>
            </BotaoPesquisar>
          </LinhaBuscar>
        )}

        {pagina?.filtro === eFiltroPagina.MENSAL && (
          <LinhaBuscar>
            <InputMes
              variant="outlined"
              margin="normal"
              // required
              // fullWidth
              autoFocus
              id="dataIni"
              label="Mês"
              name="dataIni"
              type="month"
              InputLabelProps={{
                shrink: true,
              }}
              inputRef={inputDataInicial}
              value={dataInicial}
              onChange={aoAlterarDataInicial}
              error={dataInicialErro !== ''}
              helperText={dataInicialErro}
            />
            <BotaoPesquisar cores={cores}>
              <button
                type="button"
                onClick={() => buscar(dataInicial, '')}
                // title="Incluir Cliente"
              >
                <div>
                  <FiSearch />
                </div>
              </button>
            </BotaoPesquisar>
          </LinhaBuscar>
        )}

        {pagina?.filtro === eFiltroPagina.ANUAL && (
          <LinhaBuscar>
            <InputAno
              variant="outlined"
              margin="normal"
              // required
              // fullWidth
              autoFocus
              id="dataIni"
              label="Ano"
              name="dataIni"
              type="year"
              InputLabelProps={{
                shrink: true,
              }}
              inputRef={inputDataInicial}
              value={dataInicial}
              onChange={aoAlterarDataInicial}
              error={dataInicialErro !== ''}
              helperText={dataInicialErro}
            />
            <BotaoPesquisar cores={cores}>
              <button
                type="button"
                onClick={() => buscar(dataInicial, '')}
                // title="Incluir Cliente"
              >
                <div>
                  <FiSearch />
                </div>
              </button>
            </BotaoPesquisar>
          </LinhaBuscar>
        )}

        {pagina?.filtro === eFiltroPagina.PERIODO && (
          <LinhaBuscar>
            <InputData
              variant="outlined"
              margin="normal"
              // required
              // fullWidth
              autoFocus
              id="dataIni"
              label="Data Inicial"
              name="dataIni"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              inputRef={inputDataInicial}
              value={dataInicial}
              onChange={aoAlterarDataInicial}
              error={dataInicialErro !== ''}
              helperText={dataInicialErro}
            />
            <InputData
              variant="outlined"
              margin="normal"
              // required
              // fullWidth
              autoFocus
              id="dataFim"
              label="Data Final"
              name="dataFim"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              inputRef={inputDataFinal}
              value={dataFinal}
              onChange={aoAlterarDataFinal}
              error={dataFinalErro !== ''}
              helperText={dataFinalErro}
            />
            <BotaoPesquisar cores={cores}>
              <button
                type="button"
                onClick={() => buscar(dataInicial, dataFinal)}
                // title="Incluir Cliente"
              >
                <div>
                  <FiSearch />
                </div>
              </button>
            </BotaoPesquisar>
          </LinhaBuscar>
        )}

        {secoes?.map((secao: ISecao) => (
          <SecaoContainer key={`secao-${secao.id}`}>
            {secao.objetos.map((dado: IObjeto, dadoIndex) => (
              <ObjetoContainer
                percentual_tela={dado.percentual_tela}
                key={`secao-${secao.id}-dado-${dadoIndex}`}
              >
                <ObjetoTitulo ehCartao={dado.tipo === 'CARD'}>
                  {dado.nome}
                </ObjetoTitulo>

                {/* Renderização do Card */}
                {dado.tipo === 'CARD' && dado.cartao && (
                  <AnimatedCard>
                    <CartaoValor
                      temDescricao={
                        dado.cartao.descricao !== undefined &&
                        dado.cartao.descricao !== null
                      }
                      temPercentual={
                        dado.cartao.percentual !== undefined &&
                        dado.cartao.percentual !== null
                      }
                    >
                      {dado.cartao.valor}
                    </CartaoValor>
                    {dado.cartao.percentual !== undefined &&
                      dado.cartao.percentual !== null && (
                        <CartaoPercentual
                          temPercentual={dado.cartao.percentual >= 0}
                        >
                          {dado.cartao.percentual >= 0 ? '↑' : '↓'}{' '}
                          {Math.abs(dado.cartao.percentual)}%
                        </CartaoPercentual>
                      )}
                    {dado.cartao.descricao !== undefined &&
                      dado.cartao.descricao !== null && (
                        <CartaoDescricao>
                          {dado.cartao.descricao}
                        </CartaoDescricao>
                      )}
                  </AnimatedCard>
                )}

                {dado.tipo === 'PIZZA' && dado.series && (
                  <ResponsiveContainer width="100%" height="80%">
                    <PieChart>
                      <defs>
                        {dado.series
                          .sort((a, b) => b.value - a.value)
                          .map((entry, index) => (
                            <linearGradient
                              key={`gradient-${index}`}
                              id={`gradient-pizza-${index}`}
                              x1="0"
                              y1="0"
                              x2="1"
                              y2="1"
                            >
                              <stop
                                offset="0%"
                                stopColor={`hsl(${
                                  (index * 40) % 360
                                }, 70%, 60%)`}
                                stopOpacity={0.8}
                              />
                              <stop
                                offset="100%"
                                stopColor={`hsl(${
                                  (index * 40) % 360
                                }, 70%, 60%)`}
                                stopOpacity={
                                  themeStyled.mode === 'dark' ? 0.1 : 0.5
                                }
                              />
                            </linearGradient>
                          ))}
                      </defs>
                      <Pie
                        data={dado.series}
                        dataKey="value"
                        nameKey="name"
                        cx="50%"
                        cy="50%"
                        outerRadius="70%"
                        fill="#8884d8"
                      >
                        {dado.series.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={`url(#gradient-pizza-${index})`} // Usa o gradiente criado
                          />
                        ))}
                      </Pie>
                      <Tooltip content={<CustomTooltip />} />
                      <Legend
                        verticalAlign="bottom"
                        wrapperStyle={{
                          color: themeStyled.textoObjeto,
                          fontSize: '12px',
                          fontFamily: 'Arial, sans-serif',
                          marginTop: '10px',
                          textAlign: 'center',
                        }}
                      />
                    </PieChart>
                  </ResponsiveContainer>
                )}

                {dado.tipo === 'ROSCA' && dado.series && (
                  <ResponsiveContainer width="100%" height="80%">
                    <PieChart>
                      <defs>
                        {dado.series
                          .sort((a, b) => b.value - a.value)
                          .map((entry, index) => (
                            <linearGradient
                              key={`gradient-${index}`}
                              id={`gradient-${index}`}
                              x1="0"
                              y1="0"
                              x2="1"
                              y2="1"
                            >
                              <stop
                                offset="0%"
                                stopColor={`hsl(${
                                  (index * 40) % 360
                                }, 70%, 60%)`}
                                stopOpacity={0.8}
                              />
                              <stop
                                offset="100%"
                                stopColor={`hsl(${
                                  (index * 40) % 360
                                }, 70%, 60%)`}
                                stopOpacity={
                                  themeStyled.mode === 'dark' ? 0.1 : 0.5
                                }
                              />
                            </linearGradient>
                          ))}
                      </defs>
                      <Pie
                        data={dado.series}
                        dataKey="value"
                        nameKey="name"
                        cx="50%"
                        cy="50%"
                        innerRadius="40%"
                        outerRadius="70%"
                        fill="#8884d8"
                      >
                        {dado.series.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={`url(#gradient-${index})`} // Usa o gradiente criado
                          />
                        ))}
                      </Pie>
                      <Tooltip content={<CustomTooltip />} />
                      <Legend
                        verticalAlign="bottom"
                        wrapperStyle={{
                          color: themeStyled.textoObjeto,
                          fontSize: '12px',
                          fontFamily: 'Arial, sans-serif',
                          marginTop: '10px',
                          textAlign: 'center',
                        }}
                      />
                    </PieChart>
                  </ResponsiveContainer>
                )}

                {dado.tipo === 'AREA' && dado.series && (
                  <ResponsiveContainer width="100%" height="85%">
                    <AreaChart
                      data={dado.series}
                      margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                    >
                      <defs>
                        <linearGradient
                          id="colorValue"
                          x1="0"
                          y1="0"
                          x2="0"
                          y2="1"
                        >
                          <stop
                            offset={themeStyled.mode === 'dark' ? '0%' : '100%'}
                            stopColor={themeStyled.serieAreaUnica}
                            stopOpacity={0.8}
                          />
                          <stop
                            offset="100%"
                            stopColor={themeStyled.serieAreaUnica}
                            stopOpacity={0}
                          />
                        </linearGradient>
                      </defs>
                      <CartesianGrid strokeDasharray="3 3" stroke="#444" />
                      <XAxis
                        dataKey="name"
                        tick={{ fill: themeStyled.textoObjeto }}
                      />
                      <YAxis tick={{ fill: themeStyled.textoObjeto }} />
                      <Tooltip
                        contentStyle={{
                          backgroundColor: 'rgba(0, 0, 0, 0.7)',
                          borderRadius: '5px',
                          border: 'none',
                        }}
                        labelStyle={{ color: '#FFF' }}
                        itemStyle={{ color: '#FFF' }}
                      />
                      <Area
                        type="monotone"
                        dataKey="value"
                        stroke={themeStyled.serieAreaUnica}
                        fillOpacity={1}
                        fill="url(#colorValue)"
                      />
                    </AreaChart>
                  </ResponsiveContainer>
                )}

                {dado.tipo === 'STACKED-AREA' && dado.multiplas_series && (
                  <ResponsiveContainer width="100%" height="85%">
                    <AreaChart
                      data={dado.multiplas_series}
                      margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                    >
                      <defs>
                        {Object.keys(dado.multiplas_series[0] || {})
                          .filter(key => key !== 'name')
                          .map((key, index) => {
                            const normalizedKey = normalizeKey(key);
                            const hue = (index * 40) % 360;
                            return (
                              <linearGradient
                                key={`gradient-stacked-area-${normalizedKey}`}
                                id={`gradient-stacked-area-${normalizedKey}`}
                                x1="0"
                                y1="0"
                                x2="0"
                                y2="1"
                              >
                                <stop
                                  offset={
                                    themeStyled.mode === 'dark' ? '5%' : '100%'
                                  }
                                  stopColor={`hsl(${hue}, 90%, 60%)`}
                                  stopOpacity={0.8}
                                />
                                <stop
                                  offset={
                                    themeStyled.mode === 'dark' ? '95%' : '100%'
                                  }
                                  stopColor={`hsl(${hue}, 90%, 60%)`}
                                  stopOpacity={0}
                                />
                              </linearGradient>
                            );
                          })}
                      </defs>
                      <CartesianGrid strokeDasharray="3 3" stroke="#444" />
                      <XAxis
                        dataKey="name"
                        tick={{ fill: themeStyled.textoObjeto }}
                      />
                      <YAxis tick={{ fill: themeStyled.textoObjeto }} />
                      <Tooltip
                        contentStyle={{
                          backgroundColor: 'rgba(0, 0, 0, 0.7)',
                          borderRadius: '5px',
                          border: 'none',
                        }}
                        labelStyle={{ color: '#FFF' }}
                        itemStyle={{ color: '#FFF' }}
                      />
                      <Legend
                        verticalAlign="bottom"
                        align="center"
                        wrapperStyle={{
                          color: themeStyled.textoObjeto,
                          fontSize: '12px',
                          fontFamily: 'Arial, sans-serif',
                          marginTop: '10px',
                          textAlign: 'center',
                        }}
                      />
                      {Object.keys(dado.multiplas_series[0] || {})
                        .filter(key => key !== 'name')
                        .map((key, index) => {
                          const normalizedKey = normalizeKey(key);
                          return (
                            <Area
                              key={key}
                              type="monotone"
                              dataKey={key}
                              stackId="1"
                              stroke={`hsl(${(index * 40) % 360}, 90%, 60%)`}
                              fill={`url(#gradient-stacked-area-${normalizedKey})`}
                            />
                          );
                        })}
                    </AreaChart>
                  </ResponsiveContainer>
                )}

                {dado.tipo === 'PERCENT-AREA' && dado.multiplas_series && (
                  <ResponsiveContainer width="100%" height="85%">
                    <AreaChart
                      data={dado.multiplas_series}
                      margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                      stackOffset="expand"
                    >
                      <defs>
                        {Object.keys(dado.multiplas_series[0] || {})
                          .filter(key => key !== 'name')
                          .map((key, index) => {
                            const normalizedKey = normalizeKey(key);
                            const hue = (index * 40) % 360;
                            return (
                              <linearGradient
                                key={`gradient-percent-area-${normalizedKey}`}
                                id={`gradient-percent-area-${normalizedKey}`}
                                x1="0"
                                y1="0"
                                x2="0"
                                y2="1"
                              >
                                <stop
                                  offset={
                                    themeStyled.mode === 'dark' ? '5%' : '100%'
                                  }
                                  stopColor={`hsl(${hue}, 90%, 60%)`}
                                  stopOpacity={0.8}
                                />
                                <stop
                                  offset={
                                    themeStyled.mode === 'dark' ? '95%' : '100%'
                                  }
                                  stopColor={`hsl(${hue}, 90%, 60%)`}
                                  stopOpacity={0}
                                />
                              </linearGradient>
                            );
                          })}
                      </defs>
                      <CartesianGrid strokeDasharray="3 3" stroke="#444" />
                      <XAxis
                        dataKey="name"
                        tick={{ fill: themeStyled.textoObjeto }}
                      />
                      <YAxis
                        tick={{ fill: themeStyled.textoObjeto }}
                        tickFormatter={value => `${(value * 100).toFixed(0)}%`}
                      />
                      <Tooltip
                        contentStyle={{
                          backgroundColor: 'rgba(0, 0, 0, 0.7)',
                          borderRadius: '5px',
                          border: 'none',
                        }}
                        labelStyle={{ color: '#FFF' }}
                        itemStyle={{ color: '#FFF' }}
                        formatter={value =>
                          typeof value === 'number'
                            ? `${(value * 100).toFixed(0)}%`
                            : value
                        }
                      />
                      <Legend
                        verticalAlign="bottom"
                        align="center"
                        wrapperStyle={{
                          color: themeStyled.textoObjeto,
                          fontSize: '12px',
                          fontFamily: 'Arial, sans-serif',
                          marginTop: '10px',
                          textAlign: 'center',
                        }}
                      />
                      {Object.keys(dado.multiplas_series[0] || {})
                        .filter(key => key !== 'name')
                        .map((key, index) => {
                          const normalizedKey = normalizeKey(key);
                          return (
                            <Area
                              key={key}
                              type="monotone"
                              dataKey={key}
                              stackId="1"
                              stroke={`hsl(${(index * 40) % 360}, 70%, 60%)`}
                              fill={`url(#gradient-percent-area-${normalizedKey})`}
                            />
                          );
                        })}
                    </AreaChart>
                  </ResponsiveContainer>
                )}

                {dado.tipo === 'BAR' && dado.multiplas_series && (
                  <ResponsiveContainer width="100%" height="85%">
                    <BarChart
                      data={[...dado.multiplas_series].sort((a, b) =>
                        a.name.localeCompare(b.name),
                      )}
                      margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                    >
                      <defs>
                        {Object.keys(dado.multiplas_series[0] || {})
                          .filter(key => key !== 'name')
                          .map((key, index, array) => {
                            const normalizedKey = normalizeKey(key);
                            const hue = (index * 40) % 360;
                            return (
                              <linearGradient
                                key={`gradient-bar-${normalizedKey}`}
                                id={`gradient-bar-${normalizedKey}`}
                                x1="0"
                                y1="0"
                                x2="0"
                                y2="1"
                              >
                                <stop
                                  offset={
                                    themeStyled.mode === 'dark' ? '0%' : '100%'
                                  }
                                  stopColor={`hsl(${hue}, 70%, 60%)`}
                                  stopOpacity={0.8}
                                />
                                <stop
                                  offset="100%"
                                  stopColor={`hsl(${hue}, 70%, 60%)`}
                                  stopOpacity={0.2}
                                />
                              </linearGradient>
                            );
                          })}
                      </defs>
                      <CartesianGrid strokeDasharray="3 3" stroke="#444" />
                      <XAxis
                        dataKey="name"
                        tick={{ fill: themeStyled.textoObjeto }}
                      />
                      <YAxis tick={{ fill: themeStyled.textoObjeto }} />
                      <Tooltip
                        contentStyle={{
                          backgroundColor: 'rgba(0, 0, 0, 0.7)',
                          borderRadius: '5px',
                          border: 'none',
                        }}
                        labelStyle={{ color: '#FFF' }}
                        itemStyle={{ color: '#FFF' }}
                        cursor={{ fill: 'transparent' }}
                      />
                      <Legend
                        verticalAlign="bottom"
                        align="center"
                        wrapperStyle={{
                          color: themeStyled.textoObjeto,
                          fontSize: '12px',
                          fontFamily: 'Arial, sans-serif',
                          marginTop: '10px',
                          textAlign: 'center',
                        }}
                      />
                      {Object.keys(dado.multiplas_series[0] || {})
                        .filter(key => key !== 'name')
                        .map((key, index) => {
                          const normalizedKey = normalizeKey(key);
                          return (
                            <Bar
                              key={normalizedKey}
                              dataKey={key}
                              fill={`url(#gradient-bar-${normalizedKey})`} // Usa o gradiente normalizado
                              barSize={20}
                              radius={[5, 5, 0, 0]}
                            />
                          );
                        })}
                    </BarChart>
                  </ResponsiveContainer>
                )}

                {dado.tipo === 'STACKED-BAR' && dado.multiplas_series && (
                  <ResponsiveContainer width="100%" height="85%">
                    <BarChart
                      data={dado.multiplas_series}
                      margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                    >
                      <defs>
                        {Object.keys(dado.multiplas_series[0] || {})
                          .filter(key => key !== 'name')
                          .map((key, index, array) => {
                            const normalizedKey = normalizeKey(key);
                            const hue = (index * 40) % 360;
                            return (
                              <linearGradient
                                key={`gradient-stacked-bar-${normalizedKey}`}
                                id={`gradient-stacked-bar-${normalizedKey}`}
                                x1="0"
                                y1="0"
                                x2="0"
                                y2="1"
                              >
                                <stop
                                  offset={
                                    themeStyled.mode === 'dark' ? '0%' : '100%'
                                  }
                                  stopColor={`hsl(${hue}, 70%, 60%)`}
                                  stopOpacity={0.8}
                                />
                                <stop
                                  offset="100%"
                                  stopColor={`hsl(${hue}, 70%, 60%)`}
                                  stopOpacity={0.2}
                                />
                              </linearGradient>
                            );
                          })}
                      </defs>
                      <CartesianGrid strokeDasharray="3 3" stroke="#444" />
                      <XAxis
                        dataKey="name"
                        tick={{ fill: themeStyled.textoObjeto }}
                      />
                      <YAxis tick={{ fill: themeStyled.textoObjeto }} />
                      <Tooltip
                        contentStyle={{
                          backgroundColor: 'rgba(0, 0, 0, 0.7)',
                          borderRadius: '5px',
                          border: 'none',
                        }}
                        labelStyle={{ color: '#FFF' }}
                        itemStyle={{ color: '#FFF' }}
                        cursor={{ fill: 'transparent' }}
                      />
                      <Legend
                        verticalAlign="bottom"
                        align="center"
                        wrapperStyle={{
                          color: themeStyled.textoObjeto,
                          fontSize: '12px',
                          fontFamily: 'Arial, sans-serif',
                          marginTop: '10px',
                          textAlign: 'center',
                        }}
                      />
                      {Object.keys(dado.multiplas_series[0] || {})
                        .filter(key => key !== 'name')
                        .map((key, index) => {
                          const normalizedKey = normalizeKey(key);
                          return (
                            <Bar
                              key={key}
                              dataKey={key}
                              stackId="1"
                              fill={`url(#gradient-stacked-bar-${normalizedKey})`} // Aplica o gradiente
                              radius={[5, 5, 0, 0]} // Opção de arredondamento (caso necessário)
                            />
                          );
                        })}
                    </BarChart>
                  </ResponsiveContainer>
                )}

                {dado.tipo === 'RADAR' && dado.graficoRadar && (
                  <ResponsiveContainer width="100%" height="80%">
                    <RadarChart
                      data={dado.graficoRadar}
                      outerRadius="90%"
                      style={{ marginTop: '35px' }}
                    >
                      <defs>
                        {Object.keys(dado.graficoRadar[0] || {})
                          .filter(
                            key => key !== 'subject' && key !== 'fullMark',
                          ) // Ignora a chave `subject`
                          .map((key, index) => (
                            <linearGradient
                              key={key}
                              id={`gradient-radar-${key}`}
                              x1="0"
                              y1="0"
                              x2="1"
                              y2="1"
                            >
                              <stop
                                offset={
                                  themeStyled.mode === 'dark' ? '0%' : '100%'
                                }
                                stopColor={`hsl(${
                                  (index * 40) % 360
                                }, 70%, 60%)`}
                                stopOpacity={0.8}
                              />
                              <stop
                                offset="100%"
                                stopColor={`hsl(${
                                  (index * 40) % 360
                                }, 70%, 60%)`}
                                stopOpacity={0.3}
                              />
                            </linearGradient>
                          ))}
                      </defs>
                      <PolarGrid stroke="#444" />
                      <PolarAngleAxis
                        dataKey="subject"
                        tick={{ fill: themeStyled.textoObjeto }}
                      />
                      <PolarRadiusAxis tick={false} axisLine={false} />
                      <Tooltip
                        contentStyle={{
                          backgroundColor: 'rgba(0, 0, 0, 0.7)',
                          borderRadius: '5px',
                          border: 'none',
                        }}
                        labelStyle={{ color: '#FFF' }}
                        itemStyle={{ color: '#FFF' }}
                      />
                      <Legend
                        verticalAlign="bottom"
                        align="center"
                        wrapperStyle={{
                          color: themeStyled.textoObjeto,
                          fontSize: '12px',
                          fontFamily: 'Arial, sans-serif',
                          marginTop: '10px',
                          textAlign: 'center',
                        }}
                      />
                      {/* Renderiza as séries dinamicamente */}
                      {Object.keys(dado.graficoRadar[0] || {})
                        .filter(key => key !== 'subject' && key !== 'fullMark')
                        .map((key, index) => (
                          <Radar
                            key={key}
                            name={key} // Nome da série
                            dataKey={key} // Chave da série nos dados
                            stroke={`hsl(${(index * 40) % 360}, 70%, 60%)`} // Cor da borda
                            fill={`url(#gradient-radar-${key})`} // Gradiente aplicado
                            fillOpacity={0.7} // Opacidade da área preenchida
                          />
                        ))}
                    </RadarChart>
                  </ResponsiveContainer>
                )}
              </ObjetoContainer>
            ))}
          </SecaoContainer>
        ))}
      </Container>
    </>
  );
};

export default Home;
